import React from 'react';
import { Button, Input, Select, Modal, notification } from '@block/plug';
import _ from 'lodash';
import { getCookie, isObject, $fetch, urlParse } from '@block/utils';
import { customReport } from '@src/utils/customReport';
import logo from '../../../imgs/logo.png';
import Url from './url';
import { doAction, encrypt, getHaiouUrl } from '../../utils';
import CountDown from './countdown';
import Yoda from './Yoda';
import './index.scss';

// 短信校验：手机号 获取短息验证码
const isEmptyString = (value: string | null | undefined) => value === null || value === undefined || value === '';
const getPattern = (pattern: string | RegExp): RegExp => {
  if (!pattern) {
    return null;
  }
  if (_.isString(pattern)) {
    return new RegExp(pattern);
  }
  return pattern as RegExp;
};

interface State {
  tenantInfo?: {
    tenantName?: string;
    // eslint-disable-next-line camelcase
    tenant_admin_email?: string;
  };
  area?: any;
  account: string;
  smsCode: string;
  check: string; // 登录方式：1手机登录，2邮箱登录
  disabled: boolean;
  validation?: {
    login?: string;
    smsCode?: string;
    account?: string;
    count?: string;
  };
  valid?: {
    account?: boolean;
    smsCode?: boolean;
    login?: boolean;
  };
  serialNumber: string; // 邮箱序列号
  visible: boolean; // yoda弹框
  requestCode: any;
  [key: string]: any;
}
interface ValidateConfig {
  required?: boolean;
  pattern?: boolean;
  validator?: boolean;
}

interface LoginType {
  backgroundCheckTypeValue?: string;
  hasSign?: boolean;
  signType?: number;
  backgroundCheckTypeIndex?: number;
}

interface Query {
  from: string;
}

class Login extends React.Component<null, State> {
  account: Input;

  smsCode: Input;

  area: Select;

  codes: Button;

  constructor(props) {
    super(props);
    this.state = {
      tenantInfo: {},
      area: {
        code: '86',
        name: '中国大陆',
        value: '86',
        label: '中国大陆',
      },
      account: '',
      smsCode: '',
      check: '1', // 登录方式：1手机登录，2邮箱登录
      disabled: false,
      validation: {},
      valid: {},
      serialNumber: null, // 邮箱序列号
      visible: false, // yoda弹框
      requestCode: null,
    };
  }

  async componentWillMount() {
    // const { hash } = window.location;
    // const arr = hash.split('/');
    const tenantUid = 1;
    const res = (await doAction(Url.check, { tenantUid }, null)) || {};
    if (res.loginStatus) {
      window.location.hash = `#/candidate/${tenantUid}/home`;
    }
    const $container = document.querySelector('.login-panel-form');
    $container.addEventListener('keydown', this.dealWithKeyBoard, false);
  }

  async componentDidMount() {
    const tenantUid = 1;
    const tenantInfo = (await doAction(Url.tenantInfo, { tenantUid }, null)) || {};
    this.setState({ tenantInfo });
    window.yodaSliderSuccess = () => {
      //  重新发送发送验证码的请求
      this.getCodes();
      this.handleClose();
    };
    window.yodaSliderFailure = (options) => {
      if (options.code === 121044) {
        const message = '授权码已过期，请刷新验证页面，重新操作';
        notification.warning({ title: '提示', message: message || '操作失败' });
        this.handleClose();
      }
    };
    customReport(`进入 cli3 houxuanren login ${process.env.BLOCK_ENV}`);
  }

  dealWithKeyBoard = (e: KeyboardEvent) => {
    if (e.keyCode === 13) {
      this._loginHandler();
    }
  };

  changeLoginMethod = () => {
    const { check } = this.state;
    this.setState({
      check: check === '1' ? '2' : '1',
      area: check === '1' ? '' : '86',
      account: '',
      validation: {},
      valid: {},
      serialNumber: null,
    });
  };

  getAreaList = async (filter = '') => {
    const data = await doAction(Url.getAreaList, { filter }, null);
    return data.pageList;
  };

  validate = async (code: string, config: ValidateConfig) => {
    const { value } = this[code].state;
    const { check } = this.state;
    const preRules = {
      account: [
        {
          required: true,
          message: check === '1' ? '手机号不能为空' : '邮箱号不能为空',
        },
        {
          whitespace: true,
          message: check === '1' ? '手机号不能为空' : '邮箱号不能为空',
        },
        {
          pattern: check === '1' ? '^([0-9]{3,24})$' : '^(.+@.+)',
          message: check === '1' ? '请输入格式正确的手机号' : '请输入格式正确的邮箱',
        },
      ],
      smsCode: [
        {
          required: true,
          message: '验证码不能为空',
        },
        {
          pattern: check === '1' ? '^[0-9]{6}$' : '^[0-9]{4}$',
          message: `请输入${check === '1' ? '6' : '4'}位数字的验证码`,
        },
      ],
    };
    const flag = await this.doValidate(code, preRules[code], value, config);
    return flag;
  };

  doValidate = async (
    code: string,
    rules: { require: boolean; message: string }[],
    value: string,
    config: ValidateConfig,
  ) => {
    let rule;
    let explain = '';
    const { validation } = this.state;
    const { valid } = this.state;
    valid[code] = true;
    for (let i = 0; i < rules.length; i += 1) {
      rule = rules[i];
      // eslint-disable-next-line guard-for-in
      for (const prop in rule) {
        // 必填项校验
        if (prop === 'required' && rule[prop] && config.required) {
          if (isEmptyString(value)) {
            valid[code] = false;
            explain = rule.message;
            break;
          }
        }
        // 正则校验
        if (prop === 'pattern' && config.pattern) {
          const pattern = getPattern(rule[prop]);
          if (pattern && !pattern.test(value)) {
            valid[code] = false;
            explain = rule.message;
            break;
          }
        }
        // 自定义校验
        if (prop === 'validator' && _.isFunction(rule[prop]) && config.validator) {
          explain = rule[prop](value);
          // 返回字符串 不为空表示校验没通过 且返回错误提示
          if (!isEmptyString(explain)) {
            valid[code] = false;
            break;
          } else {
            explain = '';
          }
        }
      }
      if (!valid[code]) {
        break;
      }
    }
    validation[code] = explain;
    this.setState({ validation, valid });
    return valid[code];
  };

  // 获取短信验证码
  getCodes = async () => {
    const { valid } = this.state;
    const accountValid = await this.validate('account', { required: true, pattern: true, validator: false });
    if (valid.account || accountValid) {
      const { account } = this.state;
      let { area } = this.state;
      if (area && isObject(area)) {
        area = area.code;
      }
      try {
        await this.validate('account', { required: false, pattern: false, validator: true });
        // await doAction(Url.sendVerifyCode, param, null);
        const uuid = getCookie('_lxsdk_cuid');
        const yodaParam = {
          mobileInterCode: area,
          uuid,
          account,
        };
        const { serialNumber } = await $fetch(Url.info, yodaParam, {});
        this.setState({
          disabled: true,
          serialNumber,
          validation: {},
          valid: {},
        });
      } catch (e) {
        if (e.data.code === 121060 && e.data.requestCode) {
          this.setState({
            visible: true,
            requestCode: e.data.requestCode,
          });
        } else {
          notification.warning({ title: '提示', message: e.message || '操作失败' });
        }
        this.setState({
          disabled: false,
          validation: { login: (e || {}).message || '', count: '', smsCode: '' },
          valid: { account: true, smsCode: true, login: true },
        });
      }
    } else {
      this.setState({ disabled: false });
    }
  };

  // 区号设置
  handleAreaChange = (data: { code?: string }) => {
    data = data || {};
    const value = data.code;
    this.setState({
      area: value,
    });
  };

  // 短信、图片验证码输入change事件
  handleInputChange = async (code, e) => {
    let { value } = e.target;
    if (value) {
      value = value.trim();
    }
    await this.setState({ [code]: value });
    const accountValid = await this.validate('account', { required: true, pattern: true, validator: false });
    if (accountValid) {
      this.setState({ [code]: value, validation: {}, valid: { account: true, smsCode: true, login: true } });
    } else {
      this.setState({ [code]: value, valid: { account: false, smsCode: true, login: true } });
    }
  };

  handleJumpByType = async (data: LoginType, tenantUid: number, status: number) => {
    tenantUid = 1;
    const { backgroundCheckTypeValue, hasSign, signType } = data;
    const canOperate = status === 1 || status === 9;
    if (backgroundCheckTypeValue === 'entry') {
      // 入职候选人
      window.location.href = `/#/candidate/${tenantUid}/home`;
      return;
    }
    if (backgroundCheckTypeValue === 'background') {
      // 入职背调
      if (!hasSign && signType !== 0) {
        window.location.href = `/#/candidate/${tenantUid}/sign`;
        return;
      }
      if (canOperate) {
        window.location.hash = `#/candidate/${tenantUid}/`;
      } else {
        window.location.href = `/#/candidate/${tenantUid}/success`;
      }
    }
  };

  // 登录
  _loginHandler = async () => {
    const accountValid = await this.validate('account', { required: true, pattern: true, validator: false });
    if (accountValid) {
      const smsCodeValid = await this.validate('smsCode', { required: true, pattern: true });
      const { serialNumber } = this.state;
      if (smsCodeValid) {
        const { account, check, smsCode } = this.state;
        let { area } = this.state;
        try {
          // const { hash } = window.location;
          // const arr = hash.split('/');
          const tenantUid = 1;
          if (area && isObject(area)) {
            area = area.code;
          }
          const uuid = getCookie('_lxsdk_cuid');
          const param = {
            area,
            check,
            account,
            tenantId: tenantUid,
            verifyCode: smsCode,
            serialNumber: serialNumber || null,
            uuid,
          };
          const res: LoginType = await doAction(Url.login, param, null);
          const { from }: Query = urlParse(window.location.href) || {};
          if (res) {
            const { backgroundCheckTypeValue, backgroundCheckTypeIndex, hasSign, signType } = res;
            window.checkTypeIndex = backgroundCheckTypeIndex; //  0 不需要背调  1 offer背调  2 offer前背调
            window.checkTypeValue = backgroundCheckTypeValue;
            window.hasSign = hasSign; // 是否签署完电子签 false  未签署  true 已签署
            window.signType = signType; // 签署类型 0 无需签署 1电子签署 2手动签署
            this.setState({ validation: {}, valid: { account: true, smsCode: true, login: true } });
            const { status, step, isOld } = (await doAction(Url.homeDetail, {}, null)) || {};
            /**
             * 登录后跳转海鸥系统
             * isOid v4.2.0 版本之前在途数据（部分状态无账号信息），资产侧无法登录
             */
            localStorage.setItem('userCode', encrypt(account));
            if (from === 'eam' && step !== 1 && !isOld) {
              window.location.href = getHaiouUrl() || '';
              return;
            }
            this.handleJumpByType(res, tenantUid, status);
          }
        } catch (e) {
          this.setState({
            validation: { login: (e || {}).message || '', count: '', smsCode: '' },
            valid: { account: true, smsCode: true, login: true },
          });
        }
      }
    }
  };

  handleClose = () => {
    this.setState({ visible: false, requestCode: null });
  };

  render() {
    const {
      area,
      check,
      smsCode,
      disabled,
      account,
      tenantInfo = {},
      validation,
      serialNumber,
      visible,
      requestCode,
    } = this.state;
    let errMessage: string;
    if (validation.account) {
      errMessage = validation.account;
    } else if (validation.smsCode) {
      errMessage = validation.smsCode;
    } else if (validation.login) {
      errMessage = validation.login;
    }
    return (
      <div className="login">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="login-content">
          <div className="login-panel">
            <div className="login-panel-form">
              <div className="login-panel-header">
                <span>
                  欢迎加入
                  {tenantInfo.tenantName}
                </span>
              </div>
              <div className="login-panel-items">
                {errMessage && <div className="errMessages">{errMessage}</div>}
                <div className="login-panel-item account">
                  {check === '1' && (
                    <Select
                      className="area"
                      size="large"
                      ref={(target) => {
                        this.area = target;
                      }}
                      placeholder="区号"
                      value={area}
                      // @ts-expect-error
                      clearIcon={false}
                      required
                      keyField="code"
                      labelField="name"
                      renderInputLabel={(option) => option.value}
                      renderOptionContent={(option: DefaultAny) => `${option.name}(${option.code})`}
                      onChange={this.handleAreaChange}
                      onFetchData={this.getAreaList}
                    />
                  )}
                  <Input
                    className={check === '1' ? 'phone' : 'mail'}
                    size="large"
                    ref={(target) => {
                      this.account = target;
                    }}
                    value={account}
                    placeholder={check === '1' ? '请输入手机号' : '请输入邮箱'}
                    onBlur={() => this.validate('account', { required: true, pattern: true, validator: false })}
                    onChange={(e) => this.handleInputChange('account', e)}
                  />
                </div>
                {check === '2' && serialNumber && (
                  <div className="login-serial">
                    请输入序列号为&nbsp;
                    {serialNumber}
                    &nbsp;的验证码
                  </div>
                )}
                <div className="login-panel-item smsCode">
                  <Input
                    ref={(target) => {
                      this.smsCode = target;
                    }}
                    size="large"
                    placeholder="请输入验证码"
                    value={smsCode}
                    onBlur={() => this.validate('account', { required: true, pattern: true })}
                    onChange={(e) => this.handleInputChange('smsCode', e)}
                  />
                  {disabled ? (
                    <CountDown
                      setTime={() => {
                        this.setState({ disabled: false });
                      }}
                    />
                  ) : (
                    <span className="getCode">
                      <Button
                        ref={(target) => {
                          this.codes = target;
                        }}
                        size="large"
                        type="primary"
                        onClick={this.getCodes}
                      >
                        获取验证码
                      </Button>
                    </span>
                  )}
                </div>
                <div className="login-panel-operates">
                  <Button className="form-btn" type="primary" onClick={() => this._loginHandler()}>
                    登录
                  </Button>
                </div>
                <div className="change-login-method">
                  切换为
                  {/* @ts-expect-error span上没type属性 */}
                  <span type="primary" onClick={this.changeLoginMethod}>
                    {check === '1' ? '邮箱登录' : '手机登录'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <p>{tenantInfo.tenant_admin_email}</p>
        </div>
        {visible && requestCode && (
          <Modal title={null} closable={false} maskClosable={false} style={{ width: '400px' }}>
            <Modal.Body>
              <div style={{ height: '165px' }}>
                <Yoda requestCode={requestCode} onSuccess={this.handleClose} />
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

export default Login;
